module.exports = __webpack_public_path__ + "img/footer_desktop.060863cc.svg";